import { Box, Card, Flex, Grid, Text } from '@workos-inc/design-system';
import * as React from 'react';
import { DjangoLogoIcon } from 'src/icons/django-logo-icon';
import { DotNetLogoIcon } from 'src/icons/dotnet-logo-icon';
import { FlaskLogoIcon } from 'src/icons/flask-logo-icon';
import { GoLogoIcon } from 'src/icons/go-logo-icon';
import { JavaLogoIcon } from 'src/icons/java-logo-icon';
import { NextJsLogoIcon } from 'src/icons/nextjs-logo-icon';
import { NodeJsLogoIcon } from 'src/icons/nodejs-logo-icon';
import { PhpLogoIcon } from 'src/icons/php-logo-icon';
import { PythonLogoIcon } from 'src/icons/python-logo-icon';
import { ReactLogoIcon } from 'src/icons/react-logo-icon';
import { RemixLogoIcon } from 'src/icons/remix-logo-icon';
import { RubyLogoIcon } from 'src/icons/ruby-logo-icon';
import { TypeScriptLogoIcon } from 'src/icons/typescript-logo-icon';
const ExampleAppsRoot: React.FC = props => <Grid columns={{
  md: '3'
}} gap="5" my="5" style={{
  gridAutoRows: 144
}} {...props} data-sentry-element="Grid" data-sentry-component="ExampleAppsRoot" data-sentry-source-file="example-apps.tsx" />;
interface ExampleAppsCardProps {
  href?: string;
  title?: string;
  children?: React.ReactNode;
}
const ExampleAppsCard = ({
  title,
  href = 'https://github.com/workos'
}: ExampleAppsCardProps) => <Card asChild data-sentry-element="Card" data-sentry-component="ExampleAppsCard" data-sentry-source-file="example-apps.tsx">
    <a href={href} rel="noreferrer" target="_blank">
      <Flex direction="column" height="100%" justify="between" data-sentry-element="Flex" data-sentry-source-file="example-apps.tsx">
        <Box style={{
        color: 'var(--gray-a9)'
      }} data-sentry-element="Box" data-sentry-source-file="example-apps.tsx">
          <Icon repo={href} data-sentry-element="Icon" data-sentry-source-file="example-apps.tsx" />
        </Box>

        <Flex direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="example-apps.tsx">
          <Text color="gray" size="2" data-sentry-element="Text" data-sentry-source-file="example-apps.tsx">
            github.com
          </Text>
          <Text size="2" weight="bold" data-sentry-element="Text" data-sentry-source-file="example-apps.tsx">
            {title}
          </Text>
        </Flex>
      </Flex>

      <Box bottom="0" height="4px" left="0" position="absolute" right="0" data-sentry-element="Box" data-sentry-source-file="example-apps.tsx">
        <LanguageStats repo={href} data-sentry-element="LanguageStats" data-sentry-source-file="example-apps.tsx" />
      </Box>
    </a>
  </Card>;
const Icon = ({
  repo
}: {
  repo: string;
}) => {
  if (repo.includes('github.com/workos/node-')) {
    return <NodeJsLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/typescript-')) {
    return <TypeScriptLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/ruby-')) {
    return <RubyLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/python-flask-')) {
    return <FlaskLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/python-django-')) {
    return <DjangoLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/go-')) {
    return <GoLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/php-')) {
    return <PhpLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/dotnet-')) {
    return <DotNetLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/java-')) {
    return <JavaLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/authkit-demo')) {
    return <TypeScriptLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/next-authkit-example')) {
    return <NextJsLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/authkit')) {
    return <TypeScriptLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/remix-authkit-example')) {
    return <RemixLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/react-authkit-example')) {
    return <ReactLogoIcon height="32" width="32" />;
  }
  if (repo.includes('github.com/workos/python-authkit-example')) {
    return <PythonLogoIcon height="32" width="32" />;
  }
  return null;
};
const LanguageStats = ({
  repo
}: {
  repo: string;
}) => {
  if (repo.includes('github.com/workos/node-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#A91F50',
        width: '57%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '28%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '15%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/typescript-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#A91F50',
        width: '50%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '28%'
      }} />
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '15%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '8%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/ruby-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#701415',
        width: '45%'
      }} />
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '29%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '23%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '3%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/python-flask-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '53%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '31%'
      }} />
        <Box style={{
        height: 4,
        background: '#3572A5',
        width: '16%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/python-django-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3572A5',
        width: '39%'
      }} />
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '39%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '22%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/go-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '40%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '37%'
      }} />
        <Box style={{
        height: 4,
        background: '#02ADD8',
        width: '23%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/java-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#B07219',
        width: '50%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '46%'
      }} />
        <Box style={{
        height: 4,
        background: '#A97BFF',
        width: '4%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/php-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#C1D026',
        width: '37%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '31%'
      }} />
        <Box style={{
        height: 4,
        background: '#4F5D95',
        width: '24%'
      }} />
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '8%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/dotnet-example-applications')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#188601',
        width: '44%'
      }} />
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '36%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '18%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '2%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/authkit-demo')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '96%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '2%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '2%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/next-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '90%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '10%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/php-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#4F5D95',
        width: '83%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '17%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/authkit')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '90%'
      }} />
        <Box style={{
        height: 4,
        background: '#563d7c',
        width: '15%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/remix-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '98%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '2%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/react-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#3078C6',
        width: '86%'
      }} />
        <Box style={{
        height: 4,
        background: '#F1E05A',
        width: '7%'
      }} />
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '7%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/ruby-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#701516',
        width: '40%'
      }} />
        <Box style={{
        height: 4,
        background: '#563d7c',
        width: '31%'
      }} />
        <Box style={{
        height: 4,
        background: '#e34c26',
        width: '29%'
      }} />
      </Flex>;
  }
  if (repo.includes('github.com/workos/python-authkit-example')) {
    return <Flex>
        <Box style={{
        height: 4,
        background: '#E34C26',
        width: '48%'
      }} />
        <Box style={{
        height: 4,
        background: '#563D7C',
        width: '27%'
      }} />
        <Box style={{
        height: 4,
        background: '#3572A5',
        width: '25%'
      }} />
      </Flex>;
  }
  return null;
};
export const ExampleApps = {
  Root: ExampleAppsRoot,
  Card: ExampleAppsCard
};